define([
	"dojo/_base/array",
	"csi/xml",
	"Apparel/ProductType",
	"./CreateThemePlacement"
], function(array, xml, ProductType) {

	return {
		canAggregatePlacement: function(/*Context*/ctx, /*FormData*/fd) {
			// summary: disable choosing placements after current placement and not in MaterialType's list of CompatibleTypes
			var ps = ctx.getParent();
			var psp = ctx.getNode();
			var pspCurrent = fd.getNode();
			var index = array.indexOf(ps.Placements, pspCurrent.$URL);
			if (pspCurrent.CanRepeat) ++index;

			if (array.indexOf(ps.Placements, psp.$URL) >= index) {
				return false;
			}

			return array.indexOf(ProductType.getByUrl(pspCurrent.MaterialType, "CompatibleTypes"), psp.MaterialType) >= 0;
		},

		onAccessActionEditPlacement: function(/*Context*/ctx, /*Action*/action) {
			return !xml.nodeHasFlag(ctx.getNode(), xml.NODE_FLAG_NODELETE);
		},

		/** refresh the store after deletion */
		postActionDeletePSP(ac) {
			ac.widget.refreshHeadingStore(ac.widget.defView.findHeading("DependsOn", false));
		},
	};
});